module.exports = __webpack_public_path__ + "img/Weapon_179.8e328e99.png";